import React, { Component } from 'react';

import OperationsOrderDetails from "../components/Operations/Order";


class OrderView extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="no-padding">
                <div className="pad-30">
                    <OperationsOrderDetails orderId={this.props.match.params.orderId} />
                </div>
            </div>
        )
    }

}

export default OrderView;



// WEBPACK FOOTER //
// ./src/views/Order.js